module.exports = __webpack_public_path__ + "static/img/kapian.a1e8ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/gongchengshi/kapian.jpg
// module id = tuts
// module chunks = 6